import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import moment from "moment";

const DayContainer = styled.div`
    display: flex;
    width: 100%;
    overflow: auto;
    margin-bottom: 10px;
    padding-bottom: 10px;
    position: relative;
    scroll-behavior: smooth;
    scrollbar-width: none;
`;

const NavigationArrow = styled.span`
    background-color: #F2F0EE;
    position: sticky;
    min-width: 24px;
    left: ${ props=> props.next ? "auto" : "0"};
    right: ${ props => props.next ? "0" : "auto"};
    cursor: pointer;
    transition: background-color 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      background-color:  ${props => props.disable ? "#F2F0EE;" : "#D2D5D7"} ;
    }

    :after{
      content: '';
      border-bottom: 2px solid ${props => props.disable ? "#D2D5D7;" : "black"};
      border-left: 2px solid ${props => props.disable ? "#D2D5D7;" : "black"};
      transform: ${props => props.next ? "translateX(-25%) rotate(225deg);" : "translateX(25%) rotate(45deg);" };
      width: 10px;
      height: 10px;
      display: block;
    }
`;

const Day = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 3px 10px;
    margin: 0 2px;
    cursor: pointer;

    div{
        color: ${ props => props.active ? ( props.selected ? "#2C4EB5" : "#1C1C1C" ) : "#D2D5D7"};
    }

    &:hover{
        background-color: #D2D5D7;
        .name, .date{
          color: white;
        }
    }

    .name{
        font-size: 12px;
        font-weight: 400;
    }

    .date{
        font-size: 18px;
        font-weight: 500;
    }
`;

class Days extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            scroll: 0,
            autoScroll: true,
            currentMonthString: null,
        };
    }

    scroll(){
        const container = document.getElementById("days-container");
        const day = document.getElementById("active-day");
        const center = container.clientWidth / 2;
        if(day){
            container.scrollTo( day.offsetLeft - center + day.offsetWidth / 2,0);
        }
    }
    scrollToPage(next){
        const container = document.getElementById("days-container");
        const day = document.querySelector('#days-container > div');
        const shift = container.clientWidth - day.clientWidth - 50;
        container.scrollTo(container.scrollLeft - shift * (next ? -1 : 1 )  ,0);
    }

    listenToScroll(event) {
        this.setState({scroll: event.target.scrollLeft, autoScroll: false});
    }

    componentDidMount(){
        document.getElementById("days-container").addEventListener('scrollend', this.listenToScroll.bind(this));
        if(this.state.autoScroll){
            this.scroll();
        }
    }

    componentDidUpdate() {
        if(this.state.currentMonthString !== this.currentMonth().format('L')){
            this.setState({currentMonthString: this.currentMonth().format('L'), autoScroll: true});
            this.props.setDay(null);
        }

        if(this.state.autoScroll){
            this.scroll();
        }
    }

    componentWillUnmount() {
        document.getElementById("days-container").removeEventListener('scrollend', this.listenToScroll.bind(this));
    }

    currentMonth(){
        return this.props.currentMonth == null ? this.props.slots[0].date.clone() : this.props.currentMonth.clone();
    }

    availableDays () {
        return this.props.slots.filter(slot => {
            return slot.date > this.currentMonth().startOf('month') &&
                slot.date < this.currentMonth().endOf('month');
        });
    }

    allDays(){
        const firstAvailableDay = this.availableDays()[0].date;
        const availableDayNumbers = this.availableDays().map(slot => slot.date.date());
        const lastDay = moment(firstAvailableDay).clone().endOf('month').date();
        const days = [];

        const year = firstAvailableDay.year();
        const month = firstAvailableDay.month();

        for (let i = 1; i <= lastDay; i++) {
            days.push({
                key: i,
                date: moment().set({year: year, month: month, date: i}),
                available: availableDayNumbers.includes(i)
            });
        }

        return days;
    }

    getFirstActiveDay(){
        const activeDay = this.allDays().find((d)=>{
            return d.available === true;
        });
        return activeDay.date;
    }

    isSelected(day){
        const currentDay = this.props.currentDay == null ? this.getFirstActiveDay() : this.props.currentDay;
        return day.date.format('YYYY-MM-DD') === currentDay.format('YYYY-MM-DD');
    }

    isNextActive() {
        const container = document.getElementById("days-container");

        return container ? container.scrollWidth - container.scrollLeft - container.clientWidth > 5 : false;
    }

    isPreviousActive() {
        const container = document.getElementById("days-container");

        return container ? container.scrollLeft  > 5 : false;
    }

    clickNext() {
        if(this.isNextActive()){
            this.scrollToPage(true);
        }
    }

    clickPrevious() {
        if(this.isPreviousActive()){
            this.scrollToPage(false);
        }
    }

    render() {
        return (
            <DayContainer id="days-container">
                <NavigationArrow
                    disable={ !this.isPreviousActive() }
                    onClick={ this.clickPrevious.bind(this) }
                />
                {
                    this.allDays().map(day => {
                        return <Day
                            id={this.isSelected(day) ? "active-day" : `day-${day.key}`}
                            key={day.key}
                            active={day.available}
                            selected={this.isSelected(day)}
                            onClick={() => {
                                if(day.available){
                                    this.props.setDay(day.date)
                                }
                            }}>
                            <div className="name">{day.date.format('ddd')}</div>
                            <div className="date">{day.date.date()}</div>

                        </Day>
                    })
                }
                <NavigationArrow
                    next={true}
                    disable={ !this.isNextActive() }
                    onClick={ this.clickNext.bind(this) }
                />
            </DayContainer>

        )
    }
}

Days.propTypes = {
    slots: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        date: PropTypes.any,
        slots:  PropTypes.arrayOf(PropTypes.any)
    })),
    currentMonth: PropTypes.any,
    currentDay: PropTypes.any,
    setDay: PropTypes.func.isRequired
};

export default Days;
